import { fetchApi } from "../utils";

const defaultEmailTo =
  process.env.NODE_ENV === "production" ? "kkc@kkcbearing.com" : "spyrocash@gmail.com";

const sendMail = ({ from = "KKC", to = defaultEmailTo, subject, html, attachments = [] }) => {
  return fetchApi(
    "mail/send",
    "POST",
    JSON.stringify({
      from,
      to,
      subject,
      html,
      attachments
    })
  );
};

export { sendMail };



// WEBPACK FOOTER //
// ./src/services/mail.js